"use client";

import ScrollProgressBar from "./ScrollProgressBar";
import BackToTopFAB from "./BackToTopFAB";

export default function PublicChromeOverlay() {
  return (
    <>
      <ScrollProgressBar />
      <BackToTopFAB />
    </>
  );
}
